import React, { useState } from "react";
import { useParams, useLocation } from "react-router-dom";

import { getDoorSign } from "../services/UserService";
import UserTable from "./UserTable";
import Box from '@mui/material/Box';

import Grid from '@mui/material/Grid';
import { Typography } from "@mui/material";

import MaterialButton from '@mui/material/Button';
function Userinfo() {

    const [photo, setPhoto] = useState()
    const { user } = useParams();
    const { state } = useLocation();
    const { group, name } = state;

    const getPhoto = async () => {
        const result = await getDoorSign(user)

        if (result.ok && result.url) {
            window.open(result.url, '_blank', 'noreferrer')
            return
        }

        setPhoto(1)
    }


    function ShowPhoto() {
        if (photo === 1) {
            return (
                <Box sx={{ width: '100%' }}>
                    <Typography>Ikke generert dørskilt</Typography>
                </Box>
            )
        } else {
            return null
        }
    }

    return (
        <div className="UserInfo">

            <Typography variant="h4">Pasientnummer: {user}</Typography>
            <Typography variant="h5">Gruppe: {group}</Typography>
            <Typography variant="h5">Navn: {name}</Typography>
            <Box style={{ marginTop: '4%' }} sx={{ flexGrow: 1 }}>
                <MaterialButton onClick={getPhoto}>Hent dørskilt</MaterialButton>
                <ShowPhoto />
                {/* <Box sx={{width: '100%'}}>
            <img src={`data:image/png;base64,${data}`} width='60%' />

        </Box> */}
                <Grid container spacing={2}>
                    <Grid item xs={3}>


                    </Grid>
                    <Grid>
                        <UserTable />
                    </Grid>
                </Grid>
            </Box>
        </div>


    );
}
export default Userinfo;